import { apiRoutes } from '@/constants/api-routes';
import type { LabelType } from '@/constants/label-types';
import { apiRequest } from './http';
import type { LabelView } from '@/types/api';

/**
 * Body for `POST /labels`. Mirrors `CreateLabelDto` on the server —
 * `alias` is the human-readable value, `labelType` picks the bucket
 * (genre / topic / reading_level / …).
 */
export interface CreateLabelPayload {
  alias: string;
  labelType: LabelType;
}

/**
 * `GET /labels` is open to every authenticated user (see
 * `server/src/modules/labels/labels.controller.ts`). The server filters by
 * `labelType` inside the query — omitting it returns every label across
 * every bucket in one payload.
 *
 * Onboarding + admin forms prefer the filtered calls so each chip grid can
 * independently paginate/cache without replaying the whole catalogue.
 *
 * `create` is admin-gated on the server; callers outside the admin editor
 * get a 403 and should surface the error via the standard toast path.
 */
export const labelsService = {
  list(labelType?: LabelType) {
    return apiRequest<LabelView[]>(apiRoutes.labels.list, {
      query: labelType ? { labelType } : undefined,
    });
  },
  create(payload: CreateLabelPayload) {
    return apiRequest<LabelView>(apiRoutes.labels.create, {
      method: 'POST',
      body: payload,
    });
  },
};
